var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"white"},[_c('v-container',[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"slide-track d-flex align-center"},_vm._l((_vm.marcas),function(img,index){return _c('div',{key:index,staticClass:"slide ma-3"},[_c('v-img',{attrs:{"src":img.src}})],1)}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }